<template>
    <div>
        <div>
            <v-row>
                <v-col cols="12" sm="6" md="4" v-for="(n, index) in contents"   :key="index">
                    <v-card flat color="blue lighten-5">
                        <v-card-text >
                            <p class="box-title"><a :href="`#/Media/Visits/guests/${n.Title.split('#')[1].substring(0,100)}`" class="subheading" >{{n.Title.split('#')[1]}}</a></p>
                        </v-card-text>
                        <v-card-text>
                            <p class="caption">{{n.Date | moment("DD-MM-YYYY")}}</p>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
        </div>
    </div>
</template>
<script>
    export default {
        props: ['contents'],
    }
</script>
<style>

</style>